import { render, staticRenderFns } from "./ChatOrderProductCard.vue?vue&type=template&id=5c5f19aa&scoped=true&"
import script from "./ChatOrderProductCard.vue?vue&type=script&lang=js&"
export * from "./ChatOrderProductCard.vue?vue&type=script&lang=js&"
import style0 from "./ChatOrderProductCard.vue?vue&type=style&index=0&id=5c5f19aa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5c5f19aa",
  null
  
)

export default component.exports